/**
 * Parse submission defaults for the browser SPA.
 * No user-facing mode picker: server auto routing only (no on-prem/legacy UI).
 */

export interface ParseSubmissionPrefs {
  /** Always "auto" in web — kept for platform adapter typing. */
  parseMode: "auto";
  cloudBurst: boolean;
}

/** Fixed prefs for all browser submits (server chooses neural/heuristic). */
export const DEFAULT_PARSE_PREFS: ParseSubmissionPrefs = {
  parseMode: "auto",
  cloudBurst: false,
};

/** @deprecated Prefer DEFAULT_PARSE_PREFS — no persisted UI prefs. */
export function loadParsePrefs(): ParseSubmissionPrefs {
  return { ...DEFAULT_PARSE_PREFS };
}

/** @deprecated No-op — parse mode is not user-configurable in web. */
export function saveParsePrefs(_prefs: ParseSubmissionPrefs): void {
  /* cleared intentionally */
}

/** Build parse submission prefs payload (always auto, no cloud burst toggle). */
export function buildSubmitParsePayload(
  filePath: string,
  prefs: ParseSubmissionPrefs = DEFAULT_PARSE_PREFS,
  locale: "en" | "tr" = "en",
): {
  filePath: string;
  parseMode: string | null;
  cloudBurst: boolean | null;
  locale: string;
} {
  void prefs;
  return {
    filePath,
    parseMode: null,
    cloudBurst: null,
    locale,
  };
}
